import { render, staticRenderFns } from "./bankCard.vue?vue&type=template&id=705fc8a8&scoped=true"
import script from "./bankCard.vue?vue&type=script&lang=js"
export * from "./bankCard.vue?vue&type=script&lang=js"
import style0 from "./bankCard.vue?vue&type=style&index=0&id=705fc8a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705fc8a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705fc8a8')) {
      api.createRecord('705fc8a8', component.options)
    } else {
      api.reload('705fc8a8', component.options)
    }
    module.hot.accept("./bankCard.vue?vue&type=template&id=705fc8a8&scoped=true", function () {
      api.rerender('705fc8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/components/bankCard.vue"
export default component.exports